import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from "gsap";
import $ from 'jquery';

gsap.registerPlugin();
gsap.registerPlugin(ScrollTrigger);



// create context
const AppContext = createContext();



// provider component
export const AppProvider = ({ children }) => {

    const navigate = useNavigate();
    const [currentPath, setCurrentPath] = useState(location.pathname);

    useEffect(() => {
        if (currentPath == "/")
            $('.loading-icon').css("opacity", 1)
        else
            $('.loading-icon').css("opacity", 0)


    }, [currentPath])

    function gpageTransition(obj) {

        console.log(" I M BOSS")
        let lastPage = window.location.pathname === "/" ? "HOME" : window.location.pathname.slice(1).toUpperCase();
        let pageName = obj === "/" ? "HOME" : obj.slice(1).toUpperCase();

        pageName = pageName.indexOf('/') > -1 ? pageName.split('/').filter(Boolean).pop() || '' : pageName;

        $('#transitionText').html(pageName);

        const tlTransitionOut = gsap.timeline();
        const tlText = gsap.timeline(
            {
                onComplete: () => {
                    $("ul.transition #transitionText").css("transform", "translate(0px, 0px)");
                }

            });

        tlText.fromTo("ul.transition #transitionText",
            {
                x: 0
            },
            {
                x: -100,
                duration: 2,
                ease: "none"
            });


        const tlTransitionIn = gsap.timeline({
            onComplete: async () => {

                navigate(obj);
                setCurrentPath(obj);

                $('#txt').css("transform", "unset");
                $('.loading-icon .eyes circle').css("opacity", 1);

                if (lastPage != pageName)
                    ScrollTrigger.killAll();

                window.scrollTo({ top: 0, left: 0 });
                document.documentElement.scrollTo({ top: 0, left: 0 });
                document.body.scrollTo({ top: 0, left: 0 });




                setTimeout(() => {

                    tlTransitionOut.to("ul.transition",
                        {
                            duration: .5,
                            clipPath: `inset(100% 0px 0px 0px)`,
                            ease: "circ.outIn",
                            delay: .3

                        });
                }, 200)



            },
        });





        tlTransitionIn.fromTo("ul.transition",
            {
                clipPath: `inset(0px 0px 100% 0px)`,
            },
            {
                duration: .5,

                clipPath: `inset(0px 0px 0px 0px)`,
                ease: "circ.inOut",

            });

    }


    function openCalender() {
        window.open(
            "https://calendar.app.google/EPMXzHEG1xTxGNFEA",
            "_blank",
            "width=900,height=800"
        );
    }

    function openCalendly() {
        const calendlyBtn = document.querySelector('.calendly-badge-content')
        calendlyBtn.click()
    }



    useEffect(()=>
    {
        // Calendly.initBadgeWidget({ url: 'https://calendly.com/robustik-official/30min', text: 'Schedule time with me', color: '#0069ff', textColor: '#ffffff', branding: true })
    //   Calendly.initBadgeWidget({ url: 'https://calendly.com/robustik/30min', text: 'Schedule time with me', color: '#0069ff', textColor: '#ffffff', branding: true });

        Calendly.initBadgeWidget({ url: 'https://calendly.com/john-robustik/short-intro', text: 'Schedule time with me', color: '#0069ff', textColor: '#ffffff', branding: true })

        
    }, [])

    return (
        <AppContext.Provider value={{ gpageTransition, openCalender, openCalendly }}>
            {children}



           
                
                {/* <script type="text/javascript">window.onload = function() {Calendly.initBadgeWidget({ url: 'https://calendly.com/robustik-official/30min', text: 'Schedule time with me', color: '#0069ff', textColor: '#ffffff', branding: true }) }</script> */}
             

            {/* <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet" />
            <script src="https://assets.calendly.com/assets/external/widget.js" type="text/javascript" async></script> */}

            {/* <script type="text/javascript" >window.onload = function() {
                setTimeout(function () {
                    Calendly.initBadgeWidget({ url: 'https://calendly.com/robustik-official/30min?primary_color=fa263d', text: 'Schedule a meeting', color: '#ffffff', textColor: '#000000', branding: true })

                }, 1000)
            }</script> */}

        </AppContext.Provider>
    );
};

// custom hook
export const useAppContext = () => useContext(AppContext);